import { createSlice } from '@reduxjs/toolkit';

const idChangeSlice = createSlice({
  name: 'idChange',
  initialState: {},
  reducers: {
    initIdValidate: state => {
      state.idCheck = null;
      state.getCode = false;
      state.errorCode = null;
    },
    getCheckBeforeChange: state => {
      state.getCode = false;
    },
    getCheckBeforeChangeSuccess: state => {
      state.errorCode = null;
    },
    getCheckBeforeChangeFail: (state, { payload }) => {
      state.errorCode = payload.errorCode;
    },
    getCheckIdValidate: (state, { payload }) => {
      state.idCheck = null;
      state.validId = payload.userId;
    },
    getCheckIdValidateSuccess: state => {
      state.idCheck = true;
    },
    getCheckIdValidateFail: (state, { payload }) => {
      state.idCheck = false;
      state.validId = null;
      state.errorCode = payload.errorCode;
    },
    modifyChangeId: () => {},
    modifyChangeIdSuccess: state => {
      state.getCode = true;
    },
    modifyIdComplete: () => {},
    modifyIdCompleteSuccess: state => {
      state.errorCode = 'MB_M_ID_LOGOUTAFTERNEWID';
    },
    modifyIdCompleteFail: (state, payload) => {
      state.errorCode = payload;
    },
  },
});

export const {
  initIdValidate,
  getCheckBeforeChange,
  getCheckBeforeChangeSuccess,
  getCheckBeforeChangeFail,
  getCheckIdValidate,
  getCheckIdValidateSuccess,
  getCheckIdValidateFail,
  modifyChangeId,
  modifyChangeIdSuccess,
  modifyIdComplete,
  modifyIdCompleteSuccess,
  modifyIdCompleteFail,
} = idChangeSlice.actions;
export default idChangeSlice.reducer;
